export const R2S_COUNTRIES = [
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'AU', name: 'Australia' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'IE', name: 'Ireland' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'MX', name: 'Mexico' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'KE', name: 'Kenya' },
  { code: 'CO', name: 'Colombia' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'AR', name: 'Argentina' },
  { code: 'CL', name: 'Chile' },
  { code: 'PE', name: 'Peru' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'UY', name: 'Uruguay' },
];

export const CountryFlagsBanner = ({ caption, bg = '#2A3B4A', sectionTestId = 'countries-banner', flagTestIdPrefix = 'flag' }) => (
  <section data-testid={sectionTestId} style={{ background: bg, padding: '3rem 1.5rem' }}>
    <div style={{ textAlign: 'center' }}>
      <p style={{ color: '#E8E6DF', fontSize: '0.95rem', lineHeight: 1.7, maxWidth: '760px', margin: '0 auto 1.5rem' }}>
        {caption}
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.85rem' }}>
        {R2S_COUNTRIES.map((c) => (
          <img
            key={c.code}
            data-testid={`${flagTestIdPrefix}-${c.code.toLowerCase()}`}
            src={`https://flagcdn.com/w40/${c.code.toLowerCase()}.png`}
            alt={`${c.name} flag`}
            title={c.name}
            style={{ width: '30px', height: '20px', maxWidth: '30px', borderRadius: '2px', boxShadow: '0 0 0 1px rgba(255,255,255,0.2)', objectFit: 'cover' }}
          />
        ))}
      </div>
    </div>
  </section>
);
